import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import {
  H1Container as HeadlineH1Container,
  H2Container as HeadlineH2Container,
} from "scmp-app/components/content/content-headline/styles";
import { Headline as MagazineStyleCardHeadline } from "scmp-app/components/content/content-item-render/variants/magazines-style-card/styles";
import { Headline as MagazineStyleLeadHeadline } from "scmp-app/components/content/content-item-render/variants/magazines-style-lead/styles";

import { SectionStyleFashionCarousel } from "./section-style-fashion-carousel";
import { SectionStyleMainArticleList } from "./section-style-main-article-list";
import {
  LeadArticle,
  StyledContentItemMagazinesStyleCard,
  StyledContentItemMagazinesStyleCardWide,
  StyledContentItemMagazinesStyleLead,
} from "./section-style-main-article-list/styles";

export const TopThreeArticleList = styled(SectionStyleMainArticleList)`
  ${LeadArticle} {
    ${StyledContentItemMagazinesStyleLead} {
      ${MagazineStyleLeadHeadline} {
        margin-block-start: 24px;

        ${theme.breakpoints.up("tablet")} {
          margin-block-start: 14px;
        }

        ${HeadlineH1Container}, ${HeadlineH2Container} {
          line-height: 34px;

          ${theme.breakpoints.up("tablet")} {
            font-size: 40px;
            line-height: 48px;
          }

          ${theme.breakpoints.up("desktop")} {
            font-size: 48px;
            line-height: 56px;
          }
        }
      }
    }
  }

  ${StyledContentItemMagazinesStyleCardWide}, ${StyledContentItemMagazinesStyleCard} {
    ${MagazineStyleCardHeadline} {
      ${HeadlineH1Container}, ${HeadlineH2Container} {
        font-size: 24px;

        ${theme.breakpoints.up("tablet")} {
          font-size: 32px;
        }
      }
    }
  }
`;

export const StyledSectionStyleMainArticleList = styled(SectionStyleMainArticleList)`
  ${MagazineStyleCardHeadline} {
    ${HeadlineH1Container}, ${HeadlineH2Container} {
      ${theme.breakpoints.down("desktop")} {
        font-size: 24px;
        line-height: 30px;
      }
    }
  }
`;

export const StyledSectionStyleFashionCarousel = styled(SectionStyleFashionCarousel)``;

export const Divider = styled.hr`
  inline-size: 100%;
  margin-block: 64px 0;

  border: none;
  border-block-end: 1px solid #d8d8d8;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 88px;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 1184px;
    margin-block-start: 168px;
  }
`;

export const BannerAdSlot = styled(AdSlot)`
  flex-direction: column-reverse;

  margin-block-start: 234px;
`;

export const Container = styled.div`
  margin-block-end: 80px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 96px;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 128px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    margin-block-end: 168px;
  }
`;
